import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Backdrop,
  CircularProgress,
  Typography,
  Box,
  Grid,
  Container,
  Paper,
  MenuItem,
  Select,
  InputLabel,
  FormControl
} from "@mui/material";
import { BsArrowRight } from "react-icons/bs";
import { useSelector } from "react-redux";
import api, { vendorApi } from "../../api/api";
import FileUploadWithPreview from "../common/FileUploadWithPreview";
import LeafletMapPicker from "../common/LeafletMapPicker";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const AddProjectModel = () => {
  const [projectName, setProjectName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [facing, setFacing] = useState("")
  const [NoOfPlots, setPlots] = useState("");
  const [files, setFiles] = useState([]); // Only allow one image
  const [previews, setPreviews] = useState([]);
  const fileInputRef = useRef();
  const [AvailablePlots, setAvailablePlots] = useState("");
  const [totalArea,setTotalArea]=useState("");
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [layoutImage, setLayoutImage] = useState(null);
  const [layoutPreview, setLayoutPreview] = useState(null);
  const [showMap, setShowMap] = useState(false);
  const [geolocation, setGeoLocation] = useState('');
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const [propertyErrors, setPropertyErrors] = useState({
    layoutImage: '',
    displayImage: '',
  });

  const [ownerName, setOwnerName] = useState("");
  const [ownerMobile, setOwnerMobile] = useState("");
  const [ownerEmail, setOwnerEmail] = useState("");
  const [ownerAddress, setOwnerAddress] = useState("");

  const [referenceName, setReferenceName] = useState("");
  const [referenceMobile, setReferenceMobile] = useState("");

const [description, setDescription] = useState("");

  const [youtubeLinks, setYoutubeLinks] = useState([""]);
  const [videoPreviews, setVideoPreviews] = useState([]);
 

    const getYoutubeEmbedUrl = (url) => {
  const match = url.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/
  );
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
};
  const handleSnackbarClose = () => setSnackbarOpen(false);
  // Handle file change event and restrict to one file
  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);

    // Prevent duplicate files
    const newFiles = selectedFiles.filter(
      (file) => !files.some((existingFile) => existingFile.name === file.name)
    );

    const newPreviews = newFiles.map((file) => URL.createObjectURL(file));

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);

    event.target.value = null;
  };

    /* ---------------- QUILL CONFIG ---------------- */
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
  ];


  // Handle file removal
  const handleRemove = () => {
    setFiles([]); // Clear files
    setPreviews([]); // Clear previews
  };
  // Form validation
  const validate = () => {
    const errors = {};
    if (!projectName) errors.projectName = "Please enter a project name.";
    if (!city) errors.city = "Please enter a city name.";
    if (!address) errors.address = "Please enter an address.";
    if (files.length === 0) errors.files = "Please select one image.";
    if (!NoOfPlots) errors.NoOfPlots = "Please enter the number of plots.";
    if (!AvailablePlots) errors.AvailablePlots = "Please enter available plots.";
    if (!selectedImage) errors.displayImage = "Please select a display image.";

    setPropertyErrors(errors);
    return Object.keys(errors).length === 0;
  };
  // Submit form to save the project
  // Submit form to save the project
  const saveProperty = async (event) => {

    event.preventDefault();
    // if (!validate()) return;
    setLoading(true);

    const fd = new FormData();
    fd.append("ProjectName", projectName);
    fd.append("City", city);
    fd.append("Address", address);
    fd.append("Description", description);

    fd.append("NoOfPlots", NoOfPlots);
    fd.append("totalArea", totalArea)
    fd.append("GeoLocation", geolocation);

    fd.append(
  "youtube_links",
  JSON.stringify(youtubeLinks.filter(link => link.trim() !== ""))
);

    fd.append("owner_name", ownerName);
    fd.append("owner_mobile", ownerMobile);
    fd.append("owner_email", ownerEmail);
    fd.append("owner_address", ownerAddress);

    fd.append("reference_name", referenceName);
    fd.append("reference_mobile", referenceMobile);

    // Append the actual file, not the array
    files.forEach((file) => {
      fd.append("images[]", file); // Append files to FormData
    });

    // Handle the selected display image (iconUrl)
    if (selectedImage) {
      fd.append("IconURL", selectedImage); // Ensure this is handled correctly in Laravel
    }
    if (layoutImage) {
      fd.append("LayoutURL", layoutImage);
    }
    for (let pair of fd.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }
    try {
      const response = await vendorApi.addProject(fd);
      setSnackbarMessage("Project added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      resetForm();
      setTimeout(() => {
        navigate("/viewProject");
      }, 2000);
    } catch (error) {
      setSnackbarMessage("Failed to add project. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const handleLayoutImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLayoutImage(file);
      setLayoutPreview(URL.createObjectURL(file));
      setPropertyErrors((prev) => ({ ...prev, layoutImage: '' }));
    }
  };

  const handleDisplayImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      setImagePreview(URL.createObjectURL(file));
      setPropertyErrors((prev) => ({ ...prev, displayImage: '' }));
    }
  };

  // Reset form after submission
  const resetForm = () => {
    setProjectName("");
    setCity("");
    setAddress("");
    setImagePreview("");
    setLayoutPreview("");
    setFiles([]); // Clear files
    setPreviews([]); // Clear previews
    setPropertyErrors({});
    setOwnerName("");
    setOwnerMobile("");
    setOwnerEmail("");
    setOwnerAddress("");
    setReferenceName("");
    setReferenceMobile("");
  };


    


  return (
    <Container sx={{ py: 5, maxWidth: "80%" }}>
      {/* Loader */}
      <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {/* Page Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{ color: "#13216E", fontWeight: 600, fontSize: "24px" }}
        >
          Add Project
        </Typography>
        <Box>
          <Link
            to="/home"
            style={{ textDecoration: "none", color: "#4E0DFF", fontSize: "18px" }}
          >
            Home
          </Link>
          <BsArrowRight style={{ margin: "-2px 8px", color: "#4E0DFF" }} />
          <Link
            to="/viewProject"
            style={{ textDecoration: "none", color: "#4E0DFF", fontSize: "18px" }}
          >
            Project
          </Link>
        </Box>
      </Box>
      {/* Form */}
      <Paper elevation={3} sx={{ p: 4 }}>
        <form onSubmit={saveProperty}>
          <Grid container spacing={3}>
            {/* Project Name */}
            <Grid item xs={12}>
              <TextField
                label="Project Name"
                fullWidth
                value={projectName}
                onChange={(event) => setProjectName(event.target.value)}
                error={!!propertyErrors.projectName}
              />
            </Grid>
            {/* City */}
            <Grid item xs={12}>
              <TextField
                label="City"
                fullWidth
                value={city}
                onChange={(event) => setCity(event.target.value)}
                error={!!propertyErrors.city}
              />
            </Grid>
            {/* Address */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="Address"
                value={address}
                onChange={(event) => setAddress(event.target.value)}
                error={!!propertyErrors.address}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                onClick={() => setShowMap(!showMap)}
                style={{
                  backgroundColor: showMap ? "#f44336" : "#4caf50",
                  color: "white",
                  padding: "6px 12px",
                  border: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "12px",
                  fontVariant: "small-caps", // corrected small caps
                  transition: "background-color 0.3s ease",
                  textTransform: "none",
                }}
              >
                {showMap ? "Hide Map" : "Pick Location on Map"}
              </Button>

              {showMap && (
                <Box sx={{ height: 400, width: "100%", marginY: 2 }}>
                  <LeafletMapPicker
                    setGeoLocation={setGeoLocation}

                  />
                </Box>
              )}

              <TextField
                fullWidth
                label="Geolocation (Lat,Lng)"
                value={geolocation}
                onChange={(e) => setGeoLocation(e.target.value)}
                margin="normal"
              />
            </Grid>

            {/* No of Plots */}
            <Grid item xs={12}>
              <TextField
                label="No of Plots"
                fullWidth
                type="number"
                value={NoOfPlots}
                onChange={(event) => setPlots(event.target.value)}
                error={!!propertyErrors.NoOfPlots}
              />
            </Grid>
             <Grid item xs={12}>
              <TextField
                label="Total Area"
                fullWidth
                type="string"
                value={totalArea}
                onChange={(event) => setTotalArea(event.target.value)}
                error={!!propertyErrors.totalArea}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{ color: "#13216e", fontWeight: 600 }}
              >
                Owner Details
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Name"
                fullWidth
                value={ownerName}
                onChange={(e) => setOwnerName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Mobile"
                fullWidth
                value={ownerMobile}
                onChange={(e) => setOwnerMobile(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Email"
                fullWidth
                value={ownerEmail}
                onChange={(e) => setOwnerEmail(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Address"
                fullWidth
                multiline
                rows={3}
                value={ownerAddress}
                onChange={(e) => setOwnerAddress(e.target.value)}
              />
            </Grid>
            {/* <Grid item xs={12} mt={2}>
              <Typography
                variant="h6"
                sx={{ color: "#13216e", fontWeight: 600 }}
              >
                Reference Details
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Reference Name"
                fullWidth
                value={referenceName}
                onChange={(e) => setReferenceName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Reference Mobile"
                fullWidth
                value={referenceMobile}
                onChange={(e) => setReferenceMobile(e.target.value)}
              />
            </Grid> */}


            {/* DESCRIPTION */}
             <Grid item xs={12}>
                          <Typography fontWeight={600}>Property Description</Typography>
                          <ReactQuill
                            value={description}
                            onChange={setDescription}
                            modules={quillModules}
                            formats={quillFormats}
                            style={{ height: 200, marginBottom: 40 }}
                          />
                        </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px" }}>
                Layout Picture
              </Typography>

              <label htmlFor="layout-image-upload" style={{ cursor: "pointer", margin: "10px 15px" }}>
                <Button
                  variant="outlined"
                  color="primary"
                  component="span"
                  sx={{
                    borderColor: "primary.main",
                    color: "#fff",
                    backgroundColor: "#1565c0",
                    "&:hover": {
                      background: "#1565c0",
                      color: "rgba(25, 118, 210, 0.04)",
                      borderColor: "#1976d2",
                    },
                  }}
                >
                  Choose Project Layout Image
                </Button>
              </label>

              <input
                id="layout-image-upload"
                type="file"
                onChange={handleLayoutImageChange}
                style={{ display: "none" }}
              />

              {layoutPreview && (
                <Box sx={{ mt: 2 }}>
                  <img
                    src={layoutPreview}
                    alt="Layout"
                    style={{
                      width: "20%",
                      height: "20%",
                      objectFit: "cover",
                      margin: 5,
                      borderRadius: 8,
                    }}
                  />
                </Box>
              )}

              {propertyErrors.layoutImage && (
                <Typography color="error">{propertyErrors.layoutImage}</Typography>
              )}
            </Grid>


            <Grid item xs={12}>
              <Typography variant="h6" sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px" }}>
                Display Picture
              </Typography>

              <label htmlFor="display-image-upload" style={{ cursor: "pointer", margin: "10px 15px" }}>
                <Button
                  variant="outlined"
                  color="primary"
                  component="span"
                  sx={{
                    borderColor: "primary.main",
                    color: "#fff",
                    backgroundColor: "#1565c0",
                    "&:hover": {
                      background: "#1565c0",
                      color: "rgba(25, 118, 210, 0.04)",
                      borderColor: "#1976d2",
                    },
                  }}
                >
                  Choose Display Image
                </Button>
              </label>

              <input
                id="display-image-upload"
                type="file"
                onChange={handleDisplayImageChange}
                style={{ display: "none" }}
              />

              {imagePreview && (
                <Box sx={{ mt: 2 }}>
                  <img
                    src={imagePreview}
                    alt="Display"
                    style={{
                      width: "20%",
                      height: "20%",
                      objectFit: "cover",
                      margin: 5,
                      borderRadius: 8,
                    }}
                  />
                </Box>
              )}

              {propertyErrors.displayImage && (
                <Typography color="error">{propertyErrors.displayImage}</Typography>
              )}
            </Grid>

            {/*
            {/* File Upload */}
            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px" }}
              >
                Gallery Images
              </Typography>
              <FileUploadWithPreview
                handleFileChange={handleFileChange}
                handleRemove={handleRemove}
                previews={previews || []}
                files={files || []}
                fileInputRef={fileInputRef}
              />
            </Grid>
          </Grid>

         <Grid item xs={12}>
           <Typography
             variant="h6"
             sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px" }}
           >
             Property Videos (YouTube URL)
           </Typography>
         
           {youtubeLinks.map((link, index) => (
             <Box key={index} sx={{ display: "flex", gap: 2, mt: 1 }}>
               <TextField
                 fullWidth
                 label={`YouTube Link ${index + 1}`}
                 placeholder="https://www.youtube.com/watch?v=XXXX"
                 value={link}
                 onChange={(e) => {
                   const updated = [...youtubeLinks];
                   updated[index] = e.target.value;
                   setYoutubeLinks(updated);
                 }}
               />
         
               {youtubeLinks.length > 1 && (
                 <Button
                   color="error"
                   onClick={() =>
                     setYoutubeLinks(youtubeLinks.filter((_, i) => i !== index))
                   }
                 >
                   Remove
                 </Button>
               )}
             </Box>
           ))}
         
           <Button sx={{ mt: 2 }} onClick={() => setYoutubeLinks([...youtubeLinks, ""])}>
             + Add Another Video
           </Button>
         
         <Grid container spacing={2} sx={{ mt: 2 }}>
           {youtubeLinks.map((link, index) => {
             const embedUrl = getYoutubeEmbedUrl(link);
             if (!embedUrl) return null;
         
             return (
               <Grid item xs={12} sm={6} md={4} key={index}>
                 <Box
                   sx={{
                     borderRadius: 2,
                     overflow: "hidden",
                     boxShadow: 2,
                   }}
                 >
                   <iframe
                     src={embedUrl}
                     width="100%"
                     height="200"
                     style={{ border: "none" }}
                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                     allowFullScreen
                     title={`youtube-${index}`}
                   />
                 </Box>
               </Grid>
             );
           })}
         </Grid>
         </Grid>


          {/* Buttons */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={resetForm}
              sx={{ mr: 2 }}
            >
              Reset
            </Button>
            <Button type="submit" variant="contained" color="primary">
              Save Changes
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};
export default AddProjectModel;